export function getVisibleEntityType(type: string | undefined | null, isDefaultType: boolean): string | null {
  if (!type || isDefaultType) {
    return null;
  }

  return type;
}

export function buildCardTitle(primary: string | number, visibleType: string | null): string {
  return visibleType ? `${primary}\n${visibleType}` : String(primary);
}
